import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
import apiConfig from './api.config'

const service = axios.create({
  baseURL: apiConfig.baseUrl
  // timeout: 20000 // 设置超时时间
})

service.interceptors.request.use(config => {
  if (localStorage.getItem('token')) {
    config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`
  } 
  return config
}, error => {
  return Promise.reject(error)
})

service.interceptors.response.use(response => {
  const res = response.data
  return res
}, (error) => {
  Message.error(error.response.
    data.message||error.message)
  if(error.response.data.message=="Token validation failed"){
    localStorage.removeItem('token')
    router.push('/login')
  }
  return Promise.reject(error)
})

export default service
